const ButtonRed = ({ clickAction, label }) => {
    return (
        <div className="rounded py-3 px-5 bg-darkRed mb-2 flex justify-center cursor-pointer" onClick={clickAction}>
            <p className="urbane-medium whitespace-nowrap text-white">{label}</p>
        </div>
    )
}

export default ButtonRed